import { useCallback, useEffect, useMemo, useRef, useState } from "react";
var DEFAULT_MOBILE = {
    mobile: "",
    mobileAreaCode: "CN_243",
};
export default function useMobileTextField(_a) {
    var rules = _a.rules, options = _a.options, _b = _a.defaultMobile, defaultMobile = _b === void 0 ? DEFAULT_MOBILE : _b, onAreaChange = _a.onAreaChange, onChange = _a.onChange;
    var mobileRef = useRef(null);
    var _c = useState(""), mobile = _c[0], setMobile = _c[1];
    var _d = useState(null), area = _d[0], setArea = _d[1];
    var handleChange = useCallback(function (e) {
        var _a, _b;
        setMobile((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value);
        onChange === null || onChange === void 0 ? void 0 : onChange({ mobile: (_b = e === null || e === void 0 ? void 0 : e.target) === null || _b === void 0 ? void 0 : _b.value, mobileAreaCode: area === null || area === void 0 ? void 0 : area.key });
    }, [area === null || area === void 0 ? void 0 : area.key]);
    var handleAreaChange = useCallback(function (val) {
        setArea(val);
        onAreaChange === null || onAreaChange === void 0 ? void 0 : onAreaChange(val === null || val === void 0 ? void 0 : val.key);
        onChange === null || onChange === void 0 ? void 0 : onChange({ mobile: mobile, mobileAreaCode: val === null || val === void 0 ? void 0 : val.key });
    }, [mobile]);
    var reset = useCallback(function () {
        setMobile(defaultMobile.mobile);
        var mobileArea = options === null || options === void 0 ? void 0 : options.find(function (n) { return n.key === ((defaultMobile === null || defaultMobile === void 0 ? void 0 : defaultMobile.mobileAreaCode) || "CN_243"); });
        setArea(mobileArea);
        onAreaChange === null || onAreaChange === void 0 ? void 0 : onAreaChange(mobileArea === null || mobileArea === void 0 ? void 0 : mobileArea.key);
    }, [defaultMobile, options]);
    var mobileTextFieldProps = useMemo(function () { return ({
        rules: rules,
        options: options,
        mobile: mobile,
        area: area,
        onAreaChange: handleAreaChange,
        onChange: handleChange,
        ref: mobileRef,
        defaultMobile: defaultMobile,
    }); }, [rules, options, area, mobile, defaultMobile]);
    useEffect(function () {
        if (defaultMobile === null || defaultMobile === void 0 ? void 0 : defaultMobile.mobile) {
            setMobile((defaultMobile === null || defaultMobile === void 0 ? void 0 : defaultMobile.mobile) || "");
        }
        var mobileArea = options === null || options === void 0 ? void 0 : options.find(function (n) { return n.key === ((defaultMobile === null || defaultMobile === void 0 ? void 0 : defaultMobile.mobileAreaCode) || "CN_243"); });
        setArea(mobileArea);
    }, [options, defaultMobile]);
    var mobileState = useMemo(function () { return ({ mobile: mobile, mobileAreaCode: (area === null || area === void 0 ? void 0 : area.key) || "CN_243" }); }, [area, mobile]);
    return {
        mobileTextFieldProps: mobileTextFieldProps,
        mobile: mobileState,
        mobileRef: mobileRef,
        reset: reset,
    };
}
